import { useEffect, useState, useCallback } from 'react';
import fetchSharingSettings from '../data/fetchSharingSettings';

/**
 * Loads:
 *  - current user's sharing settings
 *  - catalog of user types + subtypes
 */
const useGetSharingSettings = (token) => {
  const [data, setData] = useState(null); // { settings, types }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const payload = await fetchSharingSettings(token);
      setData(payload);
    } catch (e) {
      console.error('useGetSharingSettings:', e);
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) load();
  }, [token, load]);

  return { data, loading, error, refetch: load };
};

export default useGetSharingSettings;
